module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/inactive/baseball-362f600976f3d99ff97bcafd9c92425e.svg";